import React from 'react';
import BalanceRecordRow from './BalanceRecordRow';

const BalanceRecordsTable = ({
  balanceRecords,
  disabled,
  editingRecord,
  submitting,
  isValueChanged,
  formatDate,
  startEditing,
  handleInputChange,
  handleUpdateBalance,
  confirmDelete,
  cancelEditing
}) => {
  return (
    <div className="employee-balance-table-container">
      <table className="employee-balance-table">
        <thead>
          <tr>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Balance (Days)</th>
            {!disabled && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {balanceRecords.map((record, index) => (
            <BalanceRecordRow
              key={record._id}
              record={record}
              index={index}
              disabled={disabled}
              editingRecord={editingRecord}
              submitting={submitting}
              isValueChanged={isValueChanged}
              formatDate={formatDate}
              startEditing={startEditing}
              handleInputChange={handleInputChange}
              handleUpdateBalance={handleUpdateBalance}
              confirmDelete={confirmDelete}
              cancelEditing={cancelEditing}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BalanceRecordsTable; 